import moment from 'moment';
import React from 'react';
import { Col, Row, Typography } from 'components';
import { Log } from 'models/Log';
import { CalendarIcon } from '../icons';
import { LogItem } from './LogItem';
import styles from './styles.module.scss';

interface LogGroupProps {
  groupName: string;
  lastLogRef?: (node: Element | null) => void;
  firstLogRef?: (node: Element | null) => void;
  logs: Log[];
  isLastGroup: boolean;
  isFirstGroup: boolean;
}

export const LogGroup: React.FC<LogGroupProps> = (props) => {
  const { groupName, logs, lastLogRef, firstLogRef, isFirstGroup, isLastGroup } = props;
  return (
    <Col span={24}>
      <Row gutter={5} className={styles.group_title}>
        <Col>
          <Typography.Text>
            <CalendarIcon />
          </Typography.Text>
        </Col>
        <Col>
          <Typography.Text>{moment(groupName).format('DD.MM.YYYY')}</Typography.Text>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          {logs.map((log, index: number) => {
            const isLast = index === logs.length - 1 && isLastGroup;
            const isFirst = index === 0 && isFirstGroup;
            return (
              <LogItem
                key={log.id}
                log={log}
                showVerticalLine={index !== logs.length - 1}
                logRef={isFirst ? firstLogRef : isLast ? lastLogRef : undefined}
              />
            );
          })}
        </Col>
      </Row>
    </Col>
  );
};
